import type {
	CatalogContentBlock,
	ContentBlockChip,
	GuaranteesBlock
} from "./blocks";

const GUARANTEE_CHIP_ICON = "guarantee";

export function guaranteesToChips(
	blocks?: CatalogContentBlock[]
): ContentBlockChip[] {
	if (!blocks) return [];
	return blocks
		.filter(
			(block): block is GuaranteesBlock =>
				block.blockType === "guarantees_block"
		)
		.flatMap((block) => block.guarantees ?? [])
		.map((row): ContentBlockChip | null => {
			const label = row?.label?.trim();
			if (!label) return null;
			const part = row.guarantee_title?.trim();
			return {
				label: part ? `${part}: ${label}` : label,
				icon: GUARANTEE_CHIP_ICON
			};
		})
		.filter((chip): chip is ContentBlockChip => chip !== null);
}
